module.exports = __webpack_public_path__ + "img/hero-05.1e84ba0b.jpg";